import React, { useState } from "react";
import ResourcesHero from "./components/ResourcesHero";
import VideoLessons from "./components/VideoLessons";
import Books from "./components/Books";

const ResourcesPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<"videos" | "books">("videos");

    return (
        <div className="min-h-screen bg-white">
            <ResourcesHero activeTab={activeTab} setActiveTab={setActiveTab} />

            {activeTab === "videos" ? <VideoLessons /> : <Books />}
        </div>
    );
};

export default ResourcesPage;
